<template>
  <!-- Persistent and without a close button: the shell behind this stays
       unusable until the user picks one of the two ways out. There is
       deliberately no @input, because neither of Modal's close paths is
       reachable, so it has nothing to report. -->
  <Modal :value="value" max-width="444px" persistent :show-close-button="false">
    <template #header>
      <Typography variant="h-5">You're on the wrong site</Typography>
    </template>
    <Typography variant="body-1" class="text-left black--text pt-4">
      Based on your credentials, you aren't authorized to access this website.
      <template v-if="redirectDomain">
        Would you like us to redirect you to the correct website?
      </template>
    </Typography>
    <!-- No redirect target means the backend could not name their site, so
         there is nothing to offer beyond the way out. -->
    <div class="d-flex justify-end pt-4">
      <template v-if="redirectDomain">
        <Button text @click="decline">No</Button>
        <Button text @click="goToCorrectSite">Yes</Button>
      </template>
      <Button v-else text @click="decline">{{ dismissLabel }}</Button>
    </div>
  </Modal>
</template>

<script>
import Button from "@/components/generic/Button.vue";
import Modal from "@/components/generic/Modal.vue";
import Typography from "@/components/generic/Typography.vue";

/**
 * ADO #189684. Shown when the user's client does not own the site they are on.
 *
 * Used from both checkpoints, which differ in what declining means: on the
 * login page there is no session yet and the user just goes back to the email
 * field, while in App.vue they are already signed in and have to be signed
 * out. Hence the neutral `decline` event and the caller-supplied dismiss
 * label, rather than this component assuming either.
 *
 * The body copy is from Kathy's comment on the ticket.
 */
export default {
  name: "WhitelabelRedirectPopup",
  components: { Button, Modal, Typography },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    /** Hostname of the site they should be on. Null when none could be resolved. */
    redirectDomain: {
      type: String,
      default: null,
    },
    /**
     * Label for the only button shown when there is no redirect to offer.
     * With a redirect the choice is Yes/No and this is unused.
     */
    dismissLabel: {
      type: String,
      default: "Close",
    },
  },
  methods: {
    goToCorrectSite() {
      // Deliberately not a logout first: logout navigates to its own returnTo
      // and would cancel this. The session left behind on this host is
      // harmless on its own — it only ever reopens this same modal.
      window.location.assign(`https://${this.redirectDomain}`);
    },
    decline() {
      this.$emit("decline");
    },
  },
};
</script>
